import { SECTION1 } from './section1';
import { SECTION2 } from './section2';
import { SECTION2_1 } from './section2_1';
import { SECTION2_2 } from './section2_2';
import { SECTION3 } from './section3';
import { SECTION4 } from './section4';
import { SECTION5 } from './section5';
import { SECTION6 } from './section6';

const Schedule3 = {
  SECTION1,
  SECTION2,
  SECTION2_1,
  SECTION2_2,
  SECTION3,
  SECTION4,
  SECTION5,
  SECTION6,
};

export default Schedule3;
